import {UserResource} from "../Api/User";

const defaultCode = {
    code: null,
    expires_at: null,
    shareable_code: null,
    user_id: null,
}

export default {
    namespaced: true,
    state: {
        enabled: false,
        loading: true,
        code: defaultCode,
    },
    mutations:{
        setStatus(state, status) {
            state.enabled = status
        },
        setLoading(state, status) {
            state.loading = status
        },
        setCode(state, code) {
            state.code = code
        }
    },
    actions: {
        load(context) {
            context.commit('setLoading', true)

            return new Promise((resolve, reject) => {
                UserResource.supportCodeStatus().then(r => {
                    context.commit('setCode', r.data)

                    if (r.data && r.data.code) {
                        context.commit('setStatus', true)
                    }

                    context.commit('setLoading', false)
                }).catch(e => { context.commit('setLoading', false); handleApiError(e) })
            })
        },
        grant(context) {
            context.commit('setLoading', true)

            return new Promise((resolve, reject) => {
                UserResource.grantSupportCode().then(r => {
                    context.commit('setCode', r.data)

                    if (r.data.code) {
                        context.commit('setStatus', true)
                    }

                    context.commit('setLoading', false)
                }).catch(e => { context.commit('setLoading', false); handleApiError(e) })
            })
        },
        revoke(context) {
            context.commit('setLoading', true)

            return new Promise((resolve, reject) => {
                UserResource.revokeSupportCode().then(r => {
                    context.commit('setCode', defaultCode)
                    context.commit('setStatus', false)
                    context.commit('setLoading', false)
                }).catch(e => { context.commit('setLoading', false); handleApiError(e) })
            })
        }
    }

}